export default __webpack_public_path__ + "static/media/premium-logo.2963a91d4771f633bb8a897a9cca8c28.svg";